var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4414 1.26953C13.1133 0.941406 12.6484 0.75 12.2109 0.75C11.7734 0.75 11.3086 0.941406 10.9805 1.26953L2.23047 10.0195C1.98438 10.2656 1.82031 10.5664 1.73828 10.8945L1 14.2305C0.945312 14.5039 1.16406 14.75 1.41016 14.75C1.4375 14.75 1.49219 14.75 1.51953 14.75C1.51953 14.75 3.81641 14.2578 4.85547 14.0117C5.18359 13.957 5.45703 13.793 5.70312 13.5469L14.4805 4.76953C15.1641 4.08594 15.1641 2.99219 14.4805 2.30859L13.4414 1.26953ZM4.77344 12.6172C4.71875 12.6992 4.63672 12.7266 4.55469 12.7539C4.0625 12.8633 3.26953 13.0273 2.58594 13.1914L3.02344 11.168C3.05078 11.0859 3.07812 11.0039 3.16016 10.9492L9.75 4.33203L11.418 6L4.77344 12.6172Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon-pencil.a0d79475d8f4344893bbbb6eac135cbd.svg";
export { ForwardRef as ReactComponent };